import { lazy, Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  FALLBACK_GOLD_RATE_PER_GRAM,
  GOLD_RATE_API_URL,
  formatGoldRate,
} from "../config/goldRate";
const PopupLeadForm = lazy(() => import("./PopupLeadForm"));

export default function FloatingActions() {
  const [showPopup, setShowPopup] = useState(false);
  const [showWhatsappHint, setShowWhatsappHint] = useState(false);
  const [showWhatsappText, setShowWhatsappText] = useState(false);
  const [popupClosed, setPopupClosed] = useState(false);
  const [showGoldRateCard, setShowGoldRateCard] = useState(false);
  const [showMobileBottomBar, setShowMobileBottomBar] = useState(false);
  const [goldRate, setGoldRate] = useState(
  FALLBACK_GOLD_RATE_PER_GRAM
);

const [goldRateLoading, setGoldRateLoading] = useState(false);

  const location = useLocation();

  const phoneE164 = "+917996800900";
  const phoneNumber = "7996800900";
  const whatsappNumber = phoneE164.replace("+", "");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=Hi%20%F0%9F%91%8B%20How%20can%20I%20help%20you%20today%3F`;

  useEffect(() => {
    setShowPopup(false);
    setShowWhatsappHint(false);
    setShowWhatsappText(false);
    setShowGoldRateCard(false);

    const popupTimer = window.setTimeout(() => {
      if (!popupClosed) {
        setShowPopup(true);
      }
    }, 15000);

    const whatsappTimer = window.setTimeout(() => {
      setShowWhatsappHint(true);
    }, 500);

    return () => {
      window.clearTimeout(popupTimer);
      window.clearTimeout(whatsappTimer);
    };
  }, [location.pathname, popupClosed]);

  useEffect(() => {
    const handleMobileEnquiry = () => {
      setPopupClosed(false);
      setShowWhatsappHint(false);
      setShowGoldRateCard(false);
      setShowPopup(true);
    };

    window.addEventListener("open-mobile-enquiry", handleMobileEnquiry);

    return () => {
      window.removeEventListener("open-mobile-enquiry", handleMobileEnquiry);
    };
  }, []);

  useEffect(() => {
    if (!showWhatsappHint || showWhatsappText) return;

    const startY =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        const currentY =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;

        const scrollDiff = Math.abs(currentY - startY);

        if (scrollDiff >= 80) {
          setShowWhatsappText(true);
        }

        ticking = false;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showWhatsappHint, showWhatsappText]);
useEffect(() => {
  const handleMobileBottomBarVisibility = () => {
    const isMobile = window.innerWidth < 768;
    const isHomePage = location.pathname === "/";

    if (!isMobile) {
      setShowMobileBottomBar(false);
      return;
    }

    // Other pages: keep same behavior
    if (!isHomePage) {
      setShowMobileBottomBar(true);
      return;
    }

    // Home page: hide while hero/banner is visible
    const heroSection = document.getElementById("home-hero");

    if (!heroSection) {
      const currentY =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      setShowMobileBottomBar(currentY > 600);
      return;
    }

    const heroBottom = heroSection.getBoundingClientRect().bottom;

    // Show bottom bar only after hero/banner is almost crossed
    setShowMobileBottomBar(heroBottom <= 80);
  };

  let ticking = false;

  const handleScrollOrResize = () => {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(() => {
      handleMobileBottomBarVisibility();
      ticking = false;
    });
  };

  handleMobileBottomBarVisibility();

  window.addEventListener("scroll", handleScrollOrResize, { passive: true });
  window.addEventListener("resize", handleScrollOrResize);

  return () => {
    window.removeEventListener("scroll", handleScrollOrResize);
    window.removeEventListener("resize", handleScrollOrResize);
  };
}, [location.pathname]);
  const openPopup = () => {
    setShowGoldRateCard(false);
    setShowPopup(true);
  };

  const closePopup = () => {
    setPopupClosed(true);
    setShowPopup(false);
  };

  const loadGoldRate = async () => {
  setGoldRateLoading(true);

  try {
    const response = await fetch(
      `${GOLD_RATE_API_URL}?v=${Date.now()}`,
      {
        method: "GET",
        cache: "no-store",
        headers: {
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API returned ${response.status}`);
    }

    const data = await response.json();
    const fetchedRate = Number(data.ratePerGram);

    if (!data.success || !Number.isFinite(fetchedRate)) {
      throw new Error("Invalid gold-rate response");
    }

    setGoldRate(fetchedRate);
  } catch (error) {
    console.error("Gold rate could not be loaded:", error);
  } finally {
    setGoldRateLoading(false);
  }
};
useEffect(() => {
  loadGoldRate();
}, []);

  const openGoldRateCard = () => {
  setShowPopup(false);
  setShowWhatsappHint(false);
  setShowGoldRateCard(true);
  loadGoldRate();
};

  const closeGoldRateCard = () => {
    setShowGoldRateCard(false);
  };

  const closeWhatsappHint = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowWhatsappHint(false);
  };
  
  return (
    <>
      {showPopup && (
        <Suspense fallback={null}>
          <PopupLeadForm
            onClose={closePopup}
            onSubmitted={() => {
              setShowPopup(false);
            }}
          />
        </Suspense>
      )}
{showGoldRateCard && (
  <div
    className="fixed inset-0 z-[1000] flex items-center justify-center bg-[#070A12]/70 px-4 backdrop-blur-[8px]"
    role="dialog"
    aria-modal="true"
    aria-label="Today's gold rate"
    onClick={closeGoldRateCard}
  >
    <div
      className="relative w-full max-w-[500px] overflow-hidden rounded-[30px] border border-[#E6D8C8]/25 bg-[#F5F0E8] shadow-[0_30px_90px_rgba(0,0,0,0.45)]"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
      <button
        type="button"
        onClick={closeGoldRateCard}
        className="absolute right-5 top-5 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-xl font-semibold text-[#182033] shadow-md transition hover:bg-[#EFE7DD]"
        aria-label="Close gold rate card"
      >
        ×
      </button>

      {/* Header Section */}
      <div className="relative overflow-hidden bg-[linear-gradient(135deg,#B97800_0%,#C98F18_52%,#E8B300_100%)] px-7 pb-10 pt-9 text-white sm:px-9">
        <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-white/10 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-20 -left-12 h-48 w-48 rounded-full bg-[#C9A6A6]/15 blur-3xl" />

        <div className="relative z-10">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 backdrop-blur-md">
            <span className="h-2 w-2 rounded-full bg-[#F8F5EF]" />
            <span className="text-[11px] font-bold uppercase tracking-[0.24em] text-white/85">
              Live Value Update
            </span>
          </div>

          <h2 className="font-serif text-[32px] font-bold leading-tight sm:text-[38px]">
            Today&apos;s 24K Gold Rate
          </h2>

          <p className="mt-3 max-w-[360px] text-[15px] leading-6 text-white/75">
            Current per gram value for quick gold selling reference.
          </p>
        </div>
      </div>

      {/* Rate Section */}
      <div className="relative px-7 pb-8 pt-7 sm:px-9">
        <div className="-mt-16 rounded-[26px] border border-[#E6DDD2] bg-white p-5 shadow-[0_18px_45px_rgba(22,24,33,0.16)]">
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.22em] text-[#B97800]">
            24K Rate Per Gram
          </p>

          <div className="flex items-end justify-between gap-4">
            <div>
              <p className="font-serif text-[50px] font-black leading-none tracking-tight text-[#151B2B] sm:text-[58px]">
               {goldRateLoading ? "Loading..." : formatGoldRate(goldRate)}
              </p>
              <p className="mt-2 text-sm font-semibold text-[#6B7280]">
                per gram
              </p>
            </div>

            <div className="hidden rounded-2xl bg-[#FFF3D1] px-4 py-3 text-right sm:block">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#B97800]">
                Purity
              </p>
              <p className="mt-1 text-2xl font-black text-[#151B2B]">24K</p>
            </div>
          </div>
        </div>

        {/* Small Details */}
        <div className="mt-5 grid grid-cols-3 gap-2">
          <div className="rounded-2xl border border-[#E6DDD2] bg-white px-3 py-3 text-center">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-[#B97800]">
              Testing
            </p>
            <p className="mt-1 text-xs font-medium text-gray-600">
              Transparent
            </p>
          </div>

          <div className="rounded-2xl border border-[#E6DDD2] bg-white px-3 py-3 text-center">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-[#B97800]">
              Payment
            </p>
            <p className="mt-1 text-xs font-medium text-gray-600">
              Instant
            </p>
          </div>

          <div className="rounded-2xl border border-[#E6DDD2] bg-white px-3 py-3 text-center">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-[#B97800]">
              Value
            </p>
            <p className="mt-1 text-xs font-medium text-gray-600">
              Accurate
            </p>
          </div>
        </div>

        <p className="mx-auto mt-5 max-w-[390px] text-center text-[14px] leading-6 text-gray-600">
          Visit G1 Gold for purity testing, accurate valuation, and a simple
          gold selling process.
        </p>
      </div>
    </div>
  </div>
)}

  {/* Premium Floating Actions - redesigned */}
<style>{`
  @keyframes g1GoldCoinRotate {
    0% {
      transform: rotateY(0deg) rotateZ(-4deg);
    }
    50% {
      transform: rotateY(180deg) rotateZ(4deg);
    }
    100% {
      transform: rotateY(360deg) rotateZ(-4deg);
    }
  }

  @keyframes g1GoldCoinFloat {
    0%, 100% {
      transform: translateY(0);
      filter:
        drop-shadow(0 12px 20px rgba(0,0,0,0.38))
        drop-shadow(0 0 12px rgba(255,214,92,0.50));
    }
    50% {
      transform: translateY(-7px);
      filter:
        drop-shadow(0 18px 28px rgba(0,0,0,0.46))
        drop-shadow(0 0 22px rgba(255,214,92,0.82));
    }
  }

  @keyframes g1GoldCoinPulseRing {
    0%, 100% {
      opacity: 0.35;
      transform: scale(0.9);
    }
    50% {
      opacity: 1;
      transform: scale(1.14);
    }
  }

  @keyframes g1GoldCoinShine {
    0% {
      transform: translateX(-140%) rotate(20deg);
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    100% {
      transform: translateX(140%) rotate(20deg);
      opacity: 0;
    }
  }

  .g1-gold-coin-button {
    animation: g1GoldCoinFloat 3.3s ease-in-out infinite;
    perspective: 900px;
  }

  .g1-gold-coin-button:hover .g1-gold-coin {
    animation-duration: 1.7s;
  }

  .g1-gold-coin {
    position: relative;
    transform-style: preserve-3d;
    animation: g1GoldCoinRotate 3.8s linear infinite;
  }

  .g1-gold-coin::before {
    content: "";
    position: absolute;
    inset: -12px;
    border-radius: 9999px;
    background: radial-gradient(circle, rgba(255,222,115,0.38), transparent 66%);
    animation: g1GoldCoinPulseRing 2.8s ease-in-out infinite;
    pointer-events: none;
  }

  .g1-gold-coin::after {
    content: "";
    position: absolute;
    top: 8px;
    left: 8px;
    height: 46px;
    width: 18px;
    border-radius: 9999px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255,255,255,0.58),
      transparent
    );
    animation: g1GoldCoinShine 3.2s ease-in-out infinite;
    pointer-events: none;
  }
`}</style>
{/* 
{/* Enquiry vertical tab - premium stacked letters */}
{/* Desktop Floating Enquiry / Call / WhatsApp - Image 2 Style */}
<style>{`
 .g1-desktop-floating-actions {
  position: fixed;
  right: 6px;
  top: 58%;
  transform: translateY(-50%);
  z-index: 70;
  flex-direction: column;
  align-items: center;
  width: 44px;
  border-radius: 999px;
  padding: 0;
  background: linear-gradient(
    180deg,
    rgba(245, 222, 11, 0.28) 0%,
    rgba(241, 207, 11, 0.28) 100%
  );
  box-shadow:
    0 10px 22px rgba(0,0,0,0.34),
    inset 0 2px 8px rgba(0,0,0,0.12);
  gap: 6px;
}

/* Hide image 2 floating buttons on mobile */
@media (max-width: 767px) {
  .g1-desktop-floating-actions {
    display: none !important;
  }
}

/* Show image 2 floating buttons only on desktop */
@media (min-width: 768px) {
  .g1-desktop-floating-actions {
    display: flex;
  }
}

  .g1-desktop-floating-item {
    position: relative;
    display: flex;
    height: 54px;
    width: 54px;
    align-items: center;
    justify-content: center;
  }

  .g1-desktop-floating-btn {
    position: relative;
    z-index: 3; /* Ensure button stays above the sliding label */
    display: flex;
    height: 52px;
    width: 52px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #ffffff;
    /* Rich, smooth gold gradient for the buttons */
    background: linear-gradient(135deg, #d4a74a 0%, #b88628 100%);
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
    transition: transform 0.25s ease, filter 0.25s ease, box-shadow 0.25s ease;
  }

  .g1-desktop-floating-btn:hover {
    transform: scale(1.05);
    filter: brightness(1.1);
    box-shadow: 0 6px 16px rgba(0,0,0,0.35);
  }

  .g1-desktop-floating-btn svg {
    height: 24px;
    width: 24px;
    fill: currentColor;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2));
  }

  /* The Black Hover Label */
  .g1-desktop-floating-tooltip {
    position: absolute;
    right: 20px; /* Start slightly hidden under the button */
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    pointer-events: none;
    white-space: nowrap;
    /* Pill shape flat on the right side */
    border-radius: 24px 0 0 24px; 
    background: #1a1a1a;
    padding: 10px 32px 10px 18px; /* Extra right padding so it hides seamlessly behind the circle */
    color: #ffffff;
    font-size: 12px;
    font-family: inherit;
    font-weight: 700;
    letter-spacing: 0.03em;
    z-index: 1; /* Sits beneath the button */
    transition: opacity 0.3s ease, right 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  /* Slide out on hover */
  .g1-desktop-floating-item:hover .g1-desktop-floating-tooltip,
  .g1-desktop-floating-item:focus-within .g1-desktop-floating-tooltip {
    opacity: 1;
    right: 40px; /* Final resting position to the left of the button */
  }
@media (min-width: 1536px) {
    .g1-desktop-floating-actions {
      right: 10px; /* Keep this updated relative to your main right setting */
    }
  }
`}</style>

<div className="g1-desktop-floating-actions hidden md:flex">
  {/* Enquiry */}
  <div className="g1-desktop-floating-item">
    <span className="g1-desktop-floating-tooltip">ENQUIRY</span>

    <button
      type="button"
      onClick={openPopup}
      className="g1-desktop-floating-btn"
      aria-label="Open enquiry form"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2C6.48 2 2 5.92 2 10.75c0 2.72 1.42 5.14 3.64 6.74L5 22l4.16-2.18c.9.24 1.85.38 2.84.38 5.52 0 10-3.92 10-8.75S17.52 2 12 2Zm0 4.2a2.4 2.4 0 1 1 0 4.8 2.4 2.4 0 0 1 0-4.8Zm4.7 9.15c0 .32-.26.58-.58.58H7.88a.58.58 0 0 1-.58-.58c0-1.72 2.14-3.12 4.7-3.12s4.7 1.4 4.7 3.12Z" />
      </svg>
    </button>
  </div>

  {/* Call */}
  <div className="g1-desktop-floating-item">
    <span className="g1-desktop-floating-tooltip">CALL</span>

    <a
      href={`tel:${phoneNumber}`}
      className="g1-desktop-floating-btn"
      aria-label="Call G1 Gold"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V21a1 1 0 0 1-1 1C10.85 22 2 13.15 2 2a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.24 1.01l-2.21 2.2Z" />
      </svg>
    </a>
  </div>

  {/* WhatsApp */}
  <div className="g1-desktop-floating-item">
    <span className="g1-desktop-floating-tooltip">WHATSAPP</span>

    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => setShowWhatsappHint(false)}
      className="g1-desktop-floating-btn"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.45 0 .09 5.36.09 11.97c0 2.11.55 4.16 1.59 5.96L0 24l6.24-1.64a11.9 11.9 0 0 0 5.82 1.48h.01c6.61 0 11.97-5.36 11.97-11.97 0-3.2-1.25-6.2-3.52-8.39ZM12.07 21.7c-1.8 0-3.56-.48-5.1-1.39l-.36-.21-3.7.97.99-3.61-.23-.37a9.78 9.78 0 0 1-1.5-5.2c0-5.42 4.41-9.83 9.84-9.83 2.63 0 5.11 1.02 6.97 2.88a9.79 9.79 0 0 1 2.88 6.95c0 5.42-4.41 9.83-9.83 9.83Zm5.39-7.36c-.3-.15-1.78-.88-2.06-.98-.28-.1-.49-.15-.69.15-.2.3-.79.98-.97 1.18-.18.2-.36.22-.66.07-.3-.15-1.28-.47-2.43-1.49-.9-.8-1.5-1.78-1.67-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.36.45-.54.15-.18.2-.3.3-.49.1-.2.05-.37-.02-.52-.07-.15-.69-1.67-.95-2.29-.25-.6-.5-.52-.69-.53h-.59c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.23 5.12 4.52.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.18-1.43-.07-.13-.28-.2-.58-.35Z" />
      </svg>
    </a>
  </div>
</div>

{/* Gold Rate premium coin with always-visible rotating feel */}
<style>{`
  @keyframes g1GoldRateCoinFloat {
    0%, 100% {
      transform: translateY(0);
      filter:
        drop-shadow(0 14px 24px rgba(0,0,0,0.42))
        drop-shadow(0 0 16px rgba(255,214,92,0.55));
    }
    50% {
      transform: translateY(-7px);
      filter:
        drop-shadow(0 20px 34px rgba(0,0,0,0.50))
        drop-shadow(0 0 26px rgba(255,214,92,0.88));
    }
  }

  @keyframes g1GoldRateCoinSoftRotate {
    0%, 100% {
      transform: rotate(-4deg) scaleX(1);
    }
    25% {
      transform: rotate(4deg) scaleX(0.92);
    }
    50% {
      transform: rotate(-3deg) scaleX(1);
    }
    75% {
      transform: rotate(4deg) scaleX(0.92);
    }
  }

  @keyframes g1GoldRateCoinShine {
    0% {
      transform: translateX(-150%) rotate(22deg);
      opacity: 0;
    }
    30% {
      opacity: 0.85;
    }
    100% {
      transform: translateX(150%) rotate(22deg);
      opacity: 0;
    }
  }

  @keyframes g1GoldRateRingPulse {
    0%, 100% {
      opacity: 0.42;
      transform: scale(0.92);
    }
    50% {
      opacity: 1;
      transform: scale(1.13);
    }
  }

  @keyframes g1GoldRateTextGlow {
    0%, 100% {
      text-shadow:
        0 1px 1px rgba(0,0,0,0.35),
        0 0 8px rgba(255,225,138,0.35);
    }
    50% {
      text-shadow:
        0 1px 1px rgba(0,0,0,0.45),
        0 0 14px rgba(255,225,138,0.72);
    }
  }

  .g1-rate-coin-button {
    animation: g1GoldRateCoinFloat 3.4s ease-in-out infinite;
  }

  .g1-rate-coin {
    position: relative;
    overflow: hidden;
    isolation: isolate;
    animation: g1GoldRateCoinSoftRotate 4.2s ease-in-out infinite;
    transform-origin: center;
  }

  .g1-rate-coin::before {
    content: "";
    position: absolute;
    inset: -13px;
    z-index: 0;
    border-radius: 999px;
    background: radial-gradient(
      circle,
      rgba(255,222,115,0.45),
      rgba(217,161,43,0.20),
      transparent 66%
    );
    animation: g1GoldRateRingPulse 2.8s ease-in-out infinite;
    pointer-events: none;
  }

  .g1-rate-coin::after {
    content: "";
    position: absolute;
    top: -35%;
    left: -28%;
    z-index: 3;
    height: 170%;
    width: 34%;
    border-radius: 999px;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255,255,255,0.62),
      transparent
    );
    animation: g1GoldRateCoinShine 3.3s ease-in-out infinite;
    pointer-events: none;
  }

  .g1-rate-coin-inner {
    position: relative;
    z-index: 2;
  }

  .g1-rate-coin-title {
    animation: g1GoldRateTextGlow 2.6s ease-in-out infinite;
  }

  .g1-rate-tooltip {
    pointer-events: none;
    opacity: 0;
    transform: translateY(-50%) translateX(-8px);
    transition: all 0.28s ease;
  }

  .g1-rate-coin-button:hover .g1-rate-tooltip {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }

  .g1-rate-coin-button:hover .g1-rate-coin {
    transform: scale(1.06);
    filter: brightness(1.08);
    animation-duration: 2.2s;
  }
`}</style>

<button
  type="button"
  onClick={openGoldRateCard}
  className="g1-rate-coin-button group hidden md:flex fixed bottom-8 left-8 z-50 h-[96px] w-[96px] items-center justify-center transition-all duration-300 hover:-translate-y-1"
  aria-label="Click to see today's gold rate"
>
  {/* Hover tooltip */}
  <span className="g1-rate-tooltip absolute left-[104px] top-1/2 z-50 min-w-[210px] rounded-full border border-[#F8E2A0]/70 bg-[linear-gradient(135deg,rgba(10,7,3,0.94)_0%,rgba(42,27,9,0.94)_100%)] px-4 py-2 text-center text-[12px] font-bold tracking-wide text-[#FFE18A] shadow-[0_14px_34px_rgba(0,0,0,0.35)] backdrop-blur-md">
    Click to see today&apos;s full gold rate
  </span>

  {/* Coin */}
  <span className="g1-rate-coin flex h-[86px] w-[86px] items-center justify-center rounded-full border border-[#FFE9A6] bg-[radial-gradient(circle_at_30%_22%,#fff7c8_0%,#f8dc77_27%,#d9a12b_58%,#9b6200_100%)] shadow-[inset_0_3px_9px_rgba(255,255,255,0.52),inset_0_-10px_16px_rgba(98,55,0,0.36),0_18px_38px_rgba(0,0,0,0.36)] transition-all duration-300">
    <span className="g1-rate-coin-inner flex h-[63px] w-[63px] flex-col items-center justify-center rounded-full border border-[#fff1b2]/80 bg-[radial-gradient(circle_at_35%_20%,#fff2b0_0%,#e4b53d_62%,#8f5800_100%)] text-[#2b1800] shadow-[inset_0_2px_8px_rgba(255,255,255,0.34),inset_0_-7px_12px_rgba(80,45,0,0.28)]">
      
      <span className="g1-rate-coin-title text-[7px] font-black uppercase leading-none tracking-[0.11em] text-[#5a3500]">
        Today&apos;s
      </span>

      <span className="g1-rate-coin-title mt-[2px] text-[7px] font-black uppercase leading-none tracking-[0.08em] text-[#5a3500]">
        Gold Rate
      </span>

      <span className="mt-[5px] text-[14px] font-black leading-none tracking-[-0.04em] text-[#1f1200]">
       {goldRateLoading ? "Loading..." : formatGoldRate(goldRate)}
      </span>

      <span className="mt-[2px] text-[12px] font-extrabold leading-none tracking-[0.08em] text-[#6b4300]">
        /g
      </span>
    </span>
  </span>
</button>
{/* Mobile bottom fixed action bar - clean premium version */}
<div
  className={`fixed bottom-0 left-0 right-0 z-[999] md:hidden transition-all duration-300 ease-out ${
    showMobileBottomBar
      ? "translate-y-0 opacity-100 pointer-events-auto"
      : "translate-y-full opacity-0 pointer-events-none"
  }`}
>
  
  <div className="mx-auto flex h-[66px] w-full max-w-[520px] overflow-hidden rounded-t-[18px] border-t border-[#e7d4a6] bg-white shadow-[0_-8px_26px_rgba(0,0,0,0.16)] pb-[env(safe-area-inset-bottom)]">

  {/* Gold Rate */}
<button
  type="button"
  onClick={openGoldRateCard}
  className="relative flex w-[36%] shrink-0 flex-col justify-center overflow-hidden bg-[linear-gradient(135deg,#f8dc73_0%,#e3b937_48%,#c28a13_100%)] px-3 text-left text-[#1f1300]"
  aria-label="View today's gold rate"
>
  {/* Green blinking light — top-left corner */}
  <span
    aria-hidden="true"
    className="pointer-events-none absolute right-[6px] top-[3px] z-10 h-[9px] w-[9px]"
  >
    <span
      className="absolute inset-0 animate-ping rounded-full bg-[#22c55e] opacity-60 motion-reduce:animate-none"
    />

    <span
      className="absolute inset-0 animate-pulse rounded-full border border-[#bbf7d0] bg-[#22c55e] shadow-[0_0_5px_#22c55e,0_0_9px_rgba(34,197,94,0.7)] motion-reduce:animate-none"
    />
  </span>

  <span className="text-[8px] font-black uppercase leading-none tracking-[0.13em]">
    Today&apos;s Gold Rate
  </span>

  <span className="mt-1 flex items-baseline gap-[2px] whitespace-nowrap font-sans text-[21px] font-black leading-none tracking-[-0.04em]">
    {goldRateLoading ? "Loading..." : formatGoldRate(goldRate)}

    <span className="text-[10px] font-extrabold tracking-normal">
      /g
    </span>
  </span>

  <span
    className="pointer-events-none absolute -right-5 top-0 h-full w-10 skew-x-[-24deg] bg-white/28"
    aria-hidden="true"
  />
</button>

    {/* Enquiry */}
    <button
      type="button"
      onClick={openPopup}
      className="flex flex-1 flex-col items-center justify-center gap-[4px] border-r border-[#e8dcc5] bg-white text-[#1f1f1f] active:bg-[#fff8e8]"
      aria-label="Open enquiry form"
    >
      <span className="flex h-[30px] w-[30px] items-center justify-center rounded-full border border-[#d6a43a]/40 bg-[#fff6df] text-[#b97800] shadow-[inset_0_1px_0_rgba(255,255,255,0.8)]">
        <svg
  className="h-[18px] w-[18px]"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  strokeWidth="2.1"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <path d="M21 11.5C21 15.64 17.19 19 12.5 19c-1.05 0-2.05-.17-2.97-.49L4 20l1.5-4.12A7.2 7.2 0 014 11.5C4 7.36 7.81 4 12.5 4S21 7.36 21 11.5z" />
  <path d="M8.8 11.5h.01" />
  <path d="M12.5 11.5h.01" />
  <path d="M16.2 11.5h.01" />
</svg>
      </span>
      <span className="text-[11px] font-bold leading-none">Enquiry</span>
    </button>

    {/* Call */}
    <a
      href={`tel:${phoneE164}`}
      className="flex flex-1 flex-col items-center justify-center gap-[4px] border-r border-[#e8dcc5] bg-white text-[#1f1f1f] active:bg-[#fff8e8]"
      aria-label="Call G1 Gold"
    >
      <span className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-[#fff4d8] text-[#c58a16]">
        <svg
          className="h-[18px] w-[18px]"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M22 16.92v3a2 2 0 01-2.18 2A19.8 19.8 0 013 5.18 2 2 0 015 3h3a2 2 0 012 1.72c.12.9.33 1.77.63 2.61a2 2 0 01-.45 2.11L9 10.6a16 16 0 006.4 6.4l1.16-1.18a2 2 0 012.11-.45c.84.3 1.71.51 2.61.63A2 2 0 0122 16.92z" />
        </svg>
      </span>
      <span className="text-[11px] font-bold leading-none">7996 800 900</span>
    </a>

    {/* WhatsApp */}
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-1 flex-col items-center justify-center gap-[4px] bg-white text-[#1f1f1f] active:bg-[#fff8e8]"
      aria-label="Chat on WhatsApp"
    >
      <span className="flex h-[30px] w-[30px] items-center justify-center rounded-full bg-[#e9fff0] text-[#16a34a]">
        <svg
          className="h-[19px] w-[19px]"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M20.52 3.48A11.86 11.86 0 0012.06 0C5.45 0 .09 5.36.09 11.97c0 2.11.55 4.16 1.59 5.96L0 24l6.24-1.64a11.9 11.9 0 005.82 1.48h.01c6.61 0 11.97-5.36 11.97-11.97 0-3.2-1.25-6.2-3.52-8.39zM12.07 21.7c-1.8 0-3.56-.48-5.1-1.39l-.36-.21-3.7.97.99-3.61-.23-.37a9.78 9.78 0 01-1.5-5.2c0-5.42 4.41-9.83 9.84-9.83 2.63 0 5.11 1.02 6.97 2.88a9.79 9.79 0 012.88 6.95c0 5.42-4.41 9.83-9.83 9.83zm5.39-7.36c-.3-.15-1.78-.88-2.06-.98-.28-.1-.49-.15-.69.15-.2.3-.79.98-.97 1.18-.18.2-.36.22-.66.07-.3-.15-1.28-.47-2.43-1.49-.9-.8-1.5-1.78-1.67-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.36.45-.54.15-.18.2-.3.3-.49.1-.2.05-.37-.02-.52-.07-.15-.69-1.67-.95-2.29-.25-.6-.5-.52-.69-.53h-.59c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.23 5.12 4.52.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.43.25-.7.25-1.3.18-1.43-.07-.13-.28-.2-.58-.35z" />
        </svg>
      </span>
      <span className="text-[11px] font-bold leading-none">WhatsApp</span>
    </a>
  </div>
</div>
    </>
  );
}